export default __webpack_public_path__ + "static/media/org-name.311ba299.svg";